// node types
export const NTYPE = {
  SYS: 'sys',
  DOMAIN: 'domain',
  DOMAIN_ALL: 'domain:all',
  DOMAIN_PAPERBIN: 'domain:paperbin',
  DOMAIN_INDICES: 'domain:indices',
  DOMAIN_BYTYPE: 'domain:byType',
  BYTYPE_TYPE: 'domain:byType:type',
  DOMAIN_BYSTATE: 'domain:byState',
  BYSTATE_AXIS: 'domain:byState:axis',
  BYSTATE_STATE: 'domain:byState:state',
  DOMAIN_DEV: 'domain:dev',
  DOMAIN_PINNED: 'domain:pinned',
  DOMAIN_DELIVERER: 'domain:deliverer',
  DELIVERER_YEAR: 'domain:deliverer:year',
  VLTYPE: 'vltype',
}

export const CONTAINER_LABELS = {
  [NTYPE.DOMAIN_DEV]: 'tnode_dev',
  [NTYPE.DOMAIN_INDICES]: 'tnode_indices',
  [NTYPE.DOMAIN_DELIVERER]: 'tnode_deliverer',
}
